// import EcoBanner from 'eco-design/sections/eco-banner-card';
// import EcoButton from 'eco-design/base/eco-button';
// import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
// import { OPEN_QUOTE_WIN_KEY } from '../FreeQuote';
import styles from './index.module.scss';
// import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import EcoImg from 'eco-design/base/eco-img';
// import EcoBanner from 'eco-design/sections/eco-banner-card';

const Banner: React.FC = () => {
    // const { locale } = getLocal();
    const { t } = useLang('Banner');

    // const imgData: { [key: string]: any } = {
    //     us: ['https://websiteoss.ecoflow.com/upload/image/1760082013137/pc_kv.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760089077467/Mob.jpg'],
    //     ca: ['https://websiteoss.ecoflow.com/upload/image/1760082013137/pc_kv.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760089077467/Mob.jpg'],
    // };
    return (
        <div className={`${styles.Banner} GtmModuleData-section`} data-section-id={'powerPreparedness-Banner'} data-section-title={t('title')}>
            {/* <EcoBanner
                layout="top-center"
                label={t('label')}
                title={t('title')}
                childrenA={
                    <div className="banner-buttons">
                        <EcoButton lType="filled" lBgColor="#fff" lFontColor="#000" lHref="#Emergency">
                            {t('btnText')}
                        </EcoButton>
                        {locale === 'us' && (
                            <EcoButton
                                className="GAQ-banner-btn GtmModuleData-btn-common"
                                lType="outlined"
                                data-btn-id="GAQ_Btn_KV"
                                onClick={() => {
                                    EcoDesignEventsBus.emit(OPEN_QUOTE_WIN_KEY, true);
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'floating_button',
                                        button_name: `GAQ_Btn_KV`,

                                        __btn_id1: `PP_Banner .GAQ-banner-btn`,
                                        __btn_id2: `GAQ_Btn_KV`,
                                        __btn_type: 'common',
                                    });
                                }}
                            >
                                {t('btnText2')}
                            </EcoButton>
                        )}
                    </div>
                }
                pc={imgData[locale][0]}
                h5={imgData[locale][1]}
            /> */}
            <EcoImg
                pc={'https://websiteoss.ecoflow.com/upload/image/1760082013137/pc_kv.jpg'}
                h5={'https://websiteoss.ecoflow.com/upload/image/1760089077467/Mob.jpg'}
                alt={t('title')}
                aria-label={t('title')}
            />
            <div className="info">
                <p className="label">{t('label')}</p>
                <p className="title">{t('title')}</p>
                <SceneEmail theme="white" type="DISASTER_PREPAREDNESS" title={t('title')} />
            </div>
        </div>
    );
};

export default Banner;
